export const BuildInfo = {timestamp:1784651514000}
